import React from 'react'
import { LOCALE } from '../../../../constants/activity-constants'
import { WORDS } from '../../../../constants/keywords'

export function tab3_text1() {
  return (
    <>
      Tu misión esta vez es hablar sin {WORDS.verguenza} <br />
      sobre el cuerpo y la sexualidad <br />
      derribando tabús.
      <br />
      <br />
      {WORDS.Escoge} tu personaje favorito, {WORDS.avanza} <br />
      por el laberinto, y {WORDS.recolecta} todos los <br />
      rombos y los elementos que te vayas <br />
      encontrando.
    </>
  )
}

export function tab3_card1() {
  return (
    <>
      Por cada <span>rombo</span> que <br /> {WORDS.atrapes}, ganarás{' '}
      <span className="--pink">1 punto.</span>
    </>
  )
}

export function tab3_card2() {
  return (
    <>
      Empezarás con <span className="--pink">3 vidas,</span> <br />{' '}
      {WORDS.debes} cuidarte de los <br />
      tabús porque te estarán <br /> persiguiendo… peeeero <br />
      tranquila, <span>¡la idea es que los {WORDS.derribes}!</span>
    </>
  )
}

export function tab3_card3() {
  return (
    <>
      <span>Cada producto Nosotras</span> <br />
      estará cargado de un poder <br />
      muy especial. El escenario y <br />
      los tabús cambiarán de color <br />
      por 12 segundos. Si en este <br />
      tiempo {WORDS.atrapas} un tabú, <br />
      <span className="--pink">ganarás 6 puntos.</span>
    </>
  )
}

export function tab3_card4() {
  return (
    <>
      <span>
        Las <span className="--pink">V</span> serán tus Bonus Track.
      </span>{' '}
      ¡{WORDS.Recogelos} y ganarás <span className="--pink">12 puntos</span>!
    </>
  )
}

export function tab3_card5() {
  return (
    <>
      <span>Serán 3 escenario</span> que se
      <br />
      repetirán aleatoriamente <br />
      para que {WORDS.pases} muchos <br />
      niveles. <span>¡Da lo mejor de {WORDS.ti}!</span>
    </>
  )
}

export function tab3_card6() {
  return (
    <>
      <span>¡Dale play al video</span> para que
      <br />
      {WORDS.ganes} <span className="--pink">6 puntos</span> adicionales!
      <br />
      Dale skip si {WORDS.quieres} continuar
      <br />
      *(No ganarás puntos)
    </>
  )
}
